export class PaymentMethodDesc {
    private brand: string|null;
    private desc: string|null;
    private error: string|null;

    constructor(brand: string|null, desc: string|null, error: string|null) {
        this.setBrand(brand);
        this.setDesc(desc);
        this.setError(error);
    }

    setBrand(newBrand:string|null) {
        this.brand = newBrand;
    }
    setDesc(newDesc:string|null) {
        this.desc = newDesc;
    }
    setError(newError:string|null) {
        this.error = newError;
    }

    getBrand() {
        return this.brand;
    }
    getDesc() {
        return this.desc;
    }
    getError() {
        return this.error;
    }
}

export async function getPaymentDesc(paymentMethodId:string, customerId:string):Promise<PaymentMethodDesc> {
    try {
        const stripe = require('stripe')(`${process.env.REACT_APP_STRIPE}`);

        const paymentMethod = await stripe.customers.retrievePaymentMethod(
            customerId,
            paymentMethodId
        );

        switch (paymentMethod.type) {
            case 'card':
                return new PaymentMethodDesc(paymentMethod.card.brand, `**** **** **** ${paymentMethod.card.last4}`, null);
            default:
                return new PaymentMethodDesc(null, null, `Not implemented ${paymentMethod.type}`);
        }
    } catch (e) {
        return new PaymentMethodDesc(null, null, e.message);
    }
}